var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emojiInputWrap"},[_c('div',{staticClass:"inputWrap"},[_c('el-input',{staticClass:"input",attrs:{"placeholder":_vm.palce,"type":_vm.type,"row":4,"autosize":""},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}}),_c('emoji',{on:{"setIcon":_vm.setIcon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }